import type { CompaniesForOffshoreServicePayload } from "@services/port-services/types";
import { getCompaniesForOffshoreService } from "@services/referenceDataApi";
import type { Company } from "@services/vessel-call/types";
import { useQuery } from "@tanstack/react-query";

export const useOffshoreServiceCompanies = <T = Company>(
  payload: CompaniesForOffshoreServicePayload,
  service: string,
) => {
  const { data = [], isLoading } = useQuery<T[]>({
    queryKey: [
      "companies-for-offshore-service",
      service,
      payload.portServiceCategoryCode,
      payload.portServiceTypeCode,
      payload.portServiceSubtypeCode,
    ],
    queryFn: () => getCompaniesForOffshoreService<T>(service, payload),
    enabled: !!payload.portServiceCategoryCode,
    refetchOnWindowFocus: false,
  });

  return { options: data, isLoading };
};
